import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { escalationWebhookService } from "@/services/agent/EscalationWebhookService";
import { EscalationWebhookPayload } from "@/types/agent/escalation-webhook";

export const useEscalationWebhook = (agentId: string | undefined) => {
  return useQuery({
    queryKey: ["escalation-webhook", agentId],
    queryFn: () => escalationWebhookService.get(agentId),
    enabled: !!agentId,
  });
};

export const useUpsertEscalationWebhook = (agentId: string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: EscalationWebhookPayload) =>
      escalationWebhookService.upsert(agentId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["escalation-webhook", agentId] });
    },
  });
};

export const useDeleteEscalationWebhook = (agentId: string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => escalationWebhookService.delete(agentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["escalation-webhook", agentId] });
    },
  });
};

export const useTestEscalationWebhook = (agentId: string | undefined) => {
  return useMutation({
    mutationFn: () => escalationWebhookService.test(agentId),
  });
};
